// packages
import ClipboardCopyElement from '@github/clipboard-copy-element';
import { computePosition, flip, offset } from '@floating-ui/dom';

/** @type {Element} */
let existingTooltipElement;

/**
 * Creates a tooltip element if it doesn't exist yet, then returns it.
 *
 * @returns {Element}
 */
function getTooltipElement() {
  if (!existingTooltipElement) {
    existingTooltipElement = document.createElement('div');
    existingTooltipElement.classList.add('clipboard-copy-tooltip');
    existingTooltipElement.textContent = 'Copied!';
    document.body.appendChild(existingTooltipElement);
  }

  return existingTooltipElement;
}

async function onClipboardCopy(/** @type {CustomEvent} */ event) {
  const target = event.target;

  // we only want to do this if it's a <clipboard-copy> element
  if (target instanceof ClipboardCopyElement) {
    // get or create the tooltip element
    const tooltip = getTooltipElement();

    // compute where it should be positioned relative to the target
    const { x, y } = await computePosition(target, tooltip, {
      middleware: [offset(6), flip()],
      placement: 'top',
    });

    // set the styles on the tooltip
    Object.assign(tooltip.style, {
      left: `${x}px`,
      top: `${y}px`,
    });

    // show the tooltip
    tooltip.classList.add('active');

    // wait a bit and then hide the tooltip
    setTimeout(() => {
      tooltip.classList.remove('active');
    }, 1000);
  }
}

document.addEventListener('clipboard-copy', onClipboardCopy);
